<template>
    <div>
        <div class="row">
            <div class="col-xs-6 card-title-row">
                <span class="ellipse-text">
                    <span class="headline"> {{ title }} </span>

                    <br />

                    <span class="label label-primary r-default-margin-s">
                        {{ $t(`reviews.admin.labelTemplate`) }}
                    </span>

                    <span
                        v-b-popover.hover.right="$t(`reviews.admin.showHC`)"
                        class="r-default-margin-s"
                    >
                        <a
                            href="https://leapsome.zendesk.com/hc/en-us/articles/115004136154"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <i class="fal fa-question-circle"></i>
                            <span class="tw-sr-only">Help Center</span>
                        </a>
                    </span>

                    <span v-if="template.name" class="color-grey">
                        {{ template.name }}
                    </span>
                    <span v-else class="color-grey">
                        New
                    </span>
                </span>
            </div>

            <template v-if="!template.isNew">
                <div class="col-xs-3">
                    <button
                        v-show="
                            template.status && template.status.globalStatus === 'templateActive'
                        "
                        class="btn btn-default btn-raised btn-block"
                        type="button"
                        @click="reviewTemplateClone()"
                    >
                        {{ $t(`reviews.list.btnClone`) }}
                    </button>
                </div>
                <div class="col-xs-3">
                    <button
                        class="btn btn-default btn-raised btn-block"
                        type="button"
                        @click="showConfirmationModal = true"
                    >
                        {{ $t(`reviews.admin.btnDeactivateTemplate`) }}
                    </button>
                </div>
            </template>
        </div>

        <l-confirmation-modal
            v-if="showConfirmationModal"
            :text="$t('reviews.admin.deactivateTemplateHelp')"
            @confirm="deactivate()"
            @cancel="showConfirmationModal = false"
        />

        <hr />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import api from "@/api";

import LConfirmationModal from "@/components/LConfirmationModal";

export default {
    components: {
        LConfirmationModal,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            template: {},
            showConfirmationModal: false,
        };
    },
    computed: {
        ...mapGetters({
            getTemplateDetails: "reviews/templates/details",
        }),
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.template = this.getTemplateDetails(this.id);
            },
        },
    },
    methods: {
        reviewTemplateClone() {
            return api
                .post("/api/reviewcycles/clone", {
                    reviewCycleId: this.template._id,
                    cloneTemplate: true,
                })
                .then(res => {
                    const id = res?.data?.reviewCycle?._id;

                    if (id) {
                        this.$router.push(`/reviews/templates/edit/${id}`);
                    }
                });
        },
        async deactivate() {
            await this.$store.dispatch({
                type: "reviews/templates/deactivate",
                payload: { id: this.template._id },
            });

            await this.$store.dispatch({
                type: "reviews/assessments/getList",
                payload: { scope: "admin" },
            });

            this.$router.push(`/reviews/templates`);
        },
    },
};
</script>
